export function eraseCookie(name) {
  createCookie(name, '', -1);
}

export function getCookie(key) {
  var keyValue = document.cookie.match('(^|;) ?' + key + '=([^;]*)(;|$)');
  return keyValue ? keyValue[2] : null;
}

export function setCookie(key, value) {
  var expires = new Date();
  expires.setTime(expires.getTime() + 1 * 24 * 60 * 60 * 1000);
  document.cookie = key + '=' + value + ';path=/' + ';expires=' + expires.toUTCString();
}
